import { Material, MaterialProperties } from '../../core/Material';
import * as THREE from 'three';

export interface PhongMaterialProperties extends MaterialProperties {
  color: string;
  specular: string;
  shininess: number;
  wireframe: boolean;
}

const properties: PhongMaterialProperties = {
  color: '#ffffff',
  specular: '#111111',
  shininess: 30,
  wireframe: false,
};

export const PhongMaterialItem: Material = {
  id: '',
  name: 'Phong Material',
  type: 'material',
  subtype: 'phong',
  properties: properties,
  fields: [
    {
      key: 'properties.color',
      type: 'color',
      label: 'Color',
      default: '#ffffff',
      panel: 'material',
    },
    {
      key: 'properties.specular',
      type: 'color',
      label: 'Specular',
      default: '#111111',
      panel: 'material',
    },
    {
      key: 'properties.shininess',
      type: 'number',
      label: 'Shininess',
      default: 30,
      min: 0,
      max: 100,
      step: 1,
      panel: 'material',
    },
    {
      key: 'properties.wireframe',
      type: 'boolean',
      label: 'Wireframe',
      default: false,
      panel: 'material',
    },
  ],
  render: (props) => {
    const { color, specular, shininess, wireframe } = props;
    return new THREE.MeshPhongMaterial({ color, specular: new THREE.Color(specular), shininess, wireframe });
  },
}; 